export class EMOJIS {
    static readonly SCORE_0 = new EMOJIS('😢', 0);
    static readonly SCORE_1 = new EMOJIS('🙁', 1);
    static readonly SCORE_2 = new EMOJIS('😐', 2);
    static readonly SCORE_3 = new EMOJIS('😃', 3);
    static readonly SCORE_4 = new EMOJIS('😁', 4);

    private constructor(public emoji: string, public score: number) {}
}
